/* eslint-disable max-len */
import { lazyLoad } from '@/utils/lazyLoad';
import GlobalGpuOnePage from '../../../GpuOne/pages/GlobalGpuOnePage';
import GPUOnePage from '../../../GpuOne/pages/GpuOnePage';
const AlertEmailContacts = lazyLoad(
	() => import('../../../AlertEmailContacts'),
);
const PrivateNetworkPage = lazyLoad(() => import('../../../PrivateNetwork'));
const LoadBalancersPage = lazyLoad(() => import('../../../LoadBalancers'));
const LoadBalancersCreate = lazyLoad(
	() => import('../../../LoadBalancers/LoadBalancersCreate'),
);
const LoadBalancersDetail = lazyLoad(
	() => import('../../../LoadBalancers/LoadBalancersDetail'),
);
const EditLoadBalancer = lazyLoad(
	() =>
		import(
			'../../../LoadBalancers/LoadBalancersDetail/components/Information/EditLoadBalancerMain'
		),
);
const K8 = lazyLoad(() => import('../../../K8'));
const CreateK8 = lazyLoad(() => import('../../../K8/CreateK8'));
const K8DetailPage = lazyLoad(() => import('../../../K8/DetailPage'));
const OrdersPage = lazyLoad(() => import('../../../Orders'));
const ClusterSetupCreatePage = lazyLoad(
	() => import('../../../ManagedBackup/ClusterSetup/CreateClusterSetup'),
);
const VMTemplatePage = lazyLoad(() => import('../../../VMTemplate'));
const AddVMTemplate = lazyLoad(
	() => import('../../../VMTemplate/AddVMTemplate'),
);
const VirtualMachinesPage = lazyLoad(() => import('../../../VirtualMachine'));
const ManagedBackupPage = lazyLoad(() => import('../../../ManagedBackup'));
const SupportContractCreatePage = lazyLoad(
	() => import('../../../AssetManagement/CreateSupportContract'),
);
const ClusterSetupEditPage = lazyLoad(
	() => import('../../../ManagedBackup/ClusterSetup/EditClusterSetup'),
);
const AllUsersPage = lazyLoad(() => import('../../../User/AllUsers/AllUsers'));
const AllProjectsPage = lazyLoad(
	() => import('../../../JiraProjects/AllJiraProjects'),
);
const VirtualMachineCreatePage = lazyLoad(
	() => import('../../../VirtualMachine/CreateVirtualMachine'),
);
const VirtualMachineDetails = lazyLoad(
	() => import('../../../VirtualMachine/VirtualMachineDetails'),
);
const AllVirtualMAchineCreate = lazyLoad(
	() => import('../../../VirtualMachine/CreateVirtualMachine/FormFile'),
);
const PrivateNetworkCreatePage = lazyLoad(
	() => import('../../../PrivateNetwork/PrivateNetworkCreate'),
);
const AddUserToNotificationPage = lazyLoad(
	() =>
		import('../../../AssetManagement/Preferences/AddUserToNotificationPage'),
);
const AllPrivateNetworksPage = lazyLoad(
	() => import('../../../PrivateNetwork/AllPrivateNetworksPage'),
);
const AllVirtualMachinesPage = lazyLoad(
	() => import('../../../VirtualMachine/AllVirtualMachines'),
);
const RegionsPage = lazyLoad(() => import('../../../Regions'));
const AddRegions = lazyLoad(
	() => import('../../../Regions/Components/AddRegion'),
);
const OneServerPage = lazyLoad(() => import('../../../OneServer'));
const AddOneServer = lazyLoad(
	() => import('../../../OneServer/Components/AddOneServer'),
);
const ContactUs = lazyLoad(() => import('../../../ContactUs'));
const EnableAlert = lazyLoad(
	() => import('../../../Customer/CustomerDetail/components/Alerts/index'),
);
const Modules = lazyLoad(() => import('../../../rbac/modules'));
const Templates = lazyLoad(() => import('../../../rbac/templates'));
const TemplateCreationPanel = lazyLoad(
	() => import('../../../rbac/templates/components/templateCreationPanel'),
);
const TemplateModules = lazyLoad(
	() => import('../../../rbac/templates/components/templateModules'),
);
const Permissions = lazyLoad(() => import('../../../rbac/permissions'));
const CreatePermission = lazyLoad(
	() => import('../../../rbac/permissions/components/createPermission'),
);
const ResourcePermissions = lazyLoad(
	() => import('../../../rbac/resourcePermissions'),
);
const CreateResourcePermission = lazyLoad(
	() => import('../../../rbac/resourcePermissions/components/createPermission'),
);
const CreateModule = lazyLoad(
	() => import('../../../rbac/modules/components/createModule'),
);
const Roles = lazyLoad(() => import('../../../rbac/roles'));
const RoleModules = lazyLoad(
	() => import('../../../rbac/roles/components/roleModules'),
);
const RoleCompanies = lazyLoad(
	() => import('../../../rbac/roles/components/roleCompanies'),
);
const RoleCompanySites = lazyLoad(
	() => import('../../../rbac/roles/components/companySites'),
);
const AttachSitesToCompany = lazyLoad(
	() => import('../../../rbac/roles/components/attachSites'),
);
const AttachCompanies = lazyLoad(
	() => import('../../../rbac/roles/components/attachCompanies'),
);
const AttachModules = lazyLoad(
	() => import('../../../rbac/roles/components/attachModules'),
);
const RoleCompaniesModules = lazyLoad(
	() => import('../../../rbac/roles/components/attachModules'),
);
const TemplatesAttachModules = lazyLoad(
	() => import('../../../rbac/templates/components/attachModules'),
);
const RoleCreationPanel = lazyLoad(
	() => import('../../../rbac/roles/components/roleCreationPanel'),
);
const RoleScopePage = lazyLoad(
	() => import('../../../rbac/roles/components/roleScope'),
);
const Teams = lazyLoad(() => import('../../../rbac/teams'));
const TeamUsers = lazyLoad(
	() => import('../../../rbac/teams/components/usersTable'),
);
const AddUsersInTeam = lazyLoad(
	() => import('../../../rbac/teams/components/addUsersInTeam'),
);
const TeamCreatePage = lazyLoad(
	() => import('../../../rbac/teams/components/teamCreate'),
);
const Customers = lazyLoad(() => import('../../../Customer'));
const CustomerDetailPage = lazyLoad(
	() => import('../../../Customer/CustomerDetail'),
);
// const QuickbooksPage = lazyLoad(() => import('../../../Quickbooks/WorklogPage'));
const TimeReportingPage = lazyLoad(() => import('../../../TimeReporting'));
const QuickbooksDetailPage = lazyLoad(
	() => import('../../../TimeReporting/components/LogsDetailPage/Index'),
);
const IntegrationsPage = lazyLoad(() => import('../../../Integrations'));
const STNServicesPage = lazyLoad(() => import('../../../Services'));
const AllTickets = lazyLoad(() => import('../../../JiraTickets/AllTickets'));
const TicketDetailPage = lazyLoad(
	() => import('../../../JiraTickets/TicketDetailPage'),
);
const MergeTicketDetailPage = lazyLoad(
	() => import('../../../JiraTickets/TicketDetailPage/MergeTicketsDetail'),
);
const ProfilePage = lazyLoad(() => import('../../../User/UserDetail'));
const CompanyUsersPage = lazyLoad(() => import('../../../User'));
const ProjectsPage = lazyLoad(() => import('../../../JiraProjects'));
const ProjectDetailPage = lazyLoad(
	() => import('../../../JiraProjects/ProjectDetails'),
);
const ProjectSubTaskDetailPage = lazyLoad(
	() => import('../../../JiraProjects/ProjectSubTask/ProjectSubtaskDetail'),
);
const SubtaskDetailPage = lazyLoad(
	() => import('../../../JiraTickets/TicketDetailPage/Subtasks/SubtasksDetail'),
);
// const DocumentStorage = lazyLoad(() => import('../../../Documents/Files'))
const TabularFolderStructure = lazyLoad(
	() => import('../../../Documents/Files/TabularFolderStructure'),
);
// const DiagramsPage = lazyLoad(() => import('../../../Documents/Diagrams'))
const DiagramsPage = lazyLoad(
	() => import('../../../Documents/Diagrams/TabsDiagrams'),
);
// const DiagramsDetail = lazyLoad(() => import('../../../Documents/Diagrams/components/DiagramsDetail'))
const DiagramsDetail = lazyLoad(
	() =>
		import('../../../Documents/Diagrams/TabsDiagrams/Diagrams/DiagramsDetail'),
);
const MSSReportsPage = lazyLoad(() => import('../../../MSSReportQueue'));
const Audits = lazyLoad(() => import('../../../Audits'));
const AllLogs = lazyLoad(() => import('../../../Audits/AllLogs'));
const Logout = lazyLoad(() => import('../../../Auth/Logout'));
const ControlGroupTemplates = lazyLoad(
	() => import('../../../ControlGroupTemplates'),
);
const VulnerabilityScans = lazyLoad(
	() => import('../../../VulnerabilityScans'),
);
const Assessments = lazyLoad(() => import('../../../Assessments'));
const EditAssessment = lazyLoad(
	() => import('../../../Assessments/components/EditAssessment'),
);
const VulnerabilityScansDashboard = lazyLoad(
	() => import('../../../VulnerabilityScans/components/Dashboard'),
);
const AssessmentsDetailView = lazyLoad(
	() => import('../../../Assessments/components/AssessmentsDetailViewRewamp'),
);
const AddAssessments = lazyLoad(
	() => import('../../../Assessments/components/AddAssessments'),
);
const VulnerabilityScansDetailStatus = lazyLoad(
	() =>
		import(
			'../../../VulnerabilityScans/components/VulnerabilityScanFindByRankDetailPage'
		),
);
const VulnerabilityScanDetailPage = lazyLoad(
	() =>
		import(
			'../../../VulnerabilityScans/components/VulnerabilityScanDetailPage'
		),
);
const MultipleVulnerabilityScansPage = lazyLoad(
	() =>
		import('../../../VulnerabilityScans/components/MultipleVulnerabilityScans'),
);
const EditCustomerTickets = lazyLoad(
	() => import('../../../JiraTickets/CustomEditTable'),
);

const VirtualMachineDashboardPage = lazyLoad(
	() => import('../../../VirtualMachine/VirtualMachineDashboard/index'),
);
const EditVulnerability = lazyLoad(
	() => import('../../../VulnerabilityScans/components/EditVulnerabiltiy'),
);
const ManageNotifications = lazyLoad(() => import('../../../Notifications'));
const AlertsDashboard = lazyLoad(() => import('../../../AllDashboards/Alerts'));
const Alerts = lazyLoad(() => import('../../../AlertsPolicy'));
const AlertsTools = lazyLoad(() => import('../../../AlertsPolicy/Tools'));
const AlertCompanyServiceList = lazyLoad(
	() => import('../../../AlertsPolicy/AlertCompanyServiceList'),
);
const AlertsMapping = lazyLoad(
	() => import('../../../AlertsPolicy/ToolsMapping'),
);
const ToolsProjects = lazyLoad(
	() => import('../../../AlertsPolicy/ToolsProjects'),
);
const QuickbooksPageDetails = lazyLoad(
	() => import('../../../TimeReporting/components/QuickbooksDetailPage'),
);
const GPUProvisioning = lazyLoad(
	() => import('../../../GpuOne/pages/GpuOnePage'),
);
const GpuOne = lazyLoad(() => import('../../../GpuOne/pages/GlobalGpuOnePage'));
const TicketDashboard = lazyLoad(() => import('../../../TicketDashboard'));
const AllProjectTickets = lazyLoad(
	() => import('../../../JiraProjects/AllProjectsTickets'),
);
const InventoryDashboard = lazyLoad(
	() => import('../../../Inventory/Dashboard'),
);
const InventoryManagement = lazyLoad(
	() => import('../../../Inventory/InventoryManagement'),
);
const OnboardingQuestionnaire = lazyLoad(
	() => import('../../../OnboardingSystem/DynamicQuestionnaire/Questionnaire'),
);
const OnboardingQuestionnaireQuestions = lazyLoad(
	() => import('../../../OnboardingSystem/DynamicQuestionnaire/Questions'),
);
const OnboardingQuestionnaireSolutions = lazyLoad(
	() =>
		import(
			'../../../OnboardingSystem/DynamicQuestionnaire/Questions/components/Sollutions'
		),
);
const OnboardingQuestionnaireSubQuestions = lazyLoad(
	() => import('../../../OnboardingSystem/DynamicQuestionnaire/SubQuestions'),
);
const OnboardingQuestionOptions = lazyLoad(
	() => import('../../../OnboardingSystem/DynamicQuestionnaire/Options'),
);
const OnboardingQuestionSubOptions = lazyLoad(
	() =>
		import('../../../OnboardingSystem/DynamicQuestionnaire/SubQuestionOptions'),
);
const OnboardingTemplates = lazyLoad(
	() => import('../../../OnboardingSystem/Templates'),
);
const LoginOnboardingFlow = lazyLoad(
	() => import('../../../OnboardingSystem/LoginOnboardingFlow'),
);
const SkusComponents = lazyLoad(() => import('../../../Skus'));
const GrafanaDashboard = lazyLoad(() => import('../../../GrafanaDashboards'));

// Grafana Dashboard Components

const GrafanaSlaHealthPage = lazyLoad(
	() => import('../../../grafana/pages/GrafanaSlaHealthPage'),
);
const GrafanaOverallSystemHealthPage = lazyLoad(
	() => import('../../../grafana/pages/GrafanaOverallSystemHealthPage'),
);
const GrafanaSlurmMonitoringPage = lazyLoad(
	() => import('../../../grafana/pages/GrafanaSlurmMonitoringPage'),
);
const GrafanaClusterConfigurationPage = lazyLoad(
	() => import('../../../grafana/pages/GrafanaClusterConfigurationPage'),
);
const GrafanaClusterUtilizationPage = lazyLoad(
	() => import('../../../grafana/pages/GrafanaClusterUtilizationPage'),
);
const GrafanaNodeDrilldownPage = lazyLoad(
	() => import('../../../grafana/pages/GrafanaNodeDrilldownPage'),
);
const GrafanaDcgmMonitoringPage = lazyLoad(
	() => import('../../../grafana/pages/GrafanaDcgmMonitoringPage'),
);
const GrafanaGpuUtilizationPage = lazyLoad(
	() => import('../../../grafana/pages/GrafanaGpuUtilizationPage'),
);
const GrafanaWeeklyBurnInChecksPage = lazyLoad(
	() => import('../../../grafana/pages/GrafanaWeeklyBurnInChecksPage'),
);
const GrafanaWeeklySdcChecksPage = lazyLoad(
	() => import('../../../grafana/pages/GrafanaWeeklySdcChecksPage'),
);
const GrafanaNetworkTrafficPage = lazyLoad(
	() => import('../../../grafana/pages/GrafanaNetworkTrafficPage'),
);
const GrafanaWeeklyNcclChecksPage = lazyLoad(
	() => import('../../../grafana/pages/GrafanaWeeklyNcclChecksPage'),
);
const GrafanaPowerConsumptionPage = lazyLoad(
	() => import('../../../grafana/pages/GrafanaPowerConsumptionPage'),
);
const GrafanaStorageUtilizationPage = lazyLoad(
	() => import('../../../grafana/pages/GrafanaStorageUtilizationPage'),
);
const GrafanaLoggingOverviewPage = lazyLoad(
	() => import('../../../grafana/pages/GrafanaLoggingOverviewPage'),
);
const GrafanaNodeLifecyclePage = lazyLoad(
	() => import('../../../grafana/pages/GrafanaNodeLifecyclePage'),
);

// Define super admin routes
const privateRoutes = [
	{ path: '/gpuone/', component: <GpuOne /> },
	{ path: '/skus/', component: <SkusComponents /> },
	{ path: '/onboarding_system/', component: <LoginOnboardingFlow /> },
	{
		path: '/onboarding_questionnaire/:questionnaireName',
		component: <OnboardingQuestionnaireQuestions />,
	},
	{
		path: '/onboarding_questionnaire/:questionnaireName/solutions/',
		component: <OnboardingQuestionnaireSolutions />,
	},
	{
		path: '/onboarding_questionnaire/:questionnaireName/sub_questions/',
		component: <OnboardingQuestionnaireSubQuestions />,
	},
	{
		path: '/onboarding_questionnaire/:questionnaireName/options/',
		component: <OnboardingQuestionOptions />,
	},
	{
		path: '/onboarding_questionnaire/:questionnaireName/sub_questions/options/',
		component: <OnboardingQuestionSubOptions />,
	},
	{ path: '/permissions_roles/', component: <Roles /> },
	{ path: '/onboarding_templates/', component: <OnboardingTemplates /> },
	{
		path: '/onboarding_questionnaire/',
		component: <OnboardingQuestionnaire />,
	},
	{ path: '/permissions_roles/create/', component: <RoleCreationPanel /> },

	{ path: '/permissions_roles/scope/', component: <RoleScopePage /> },
	// { path: '/permissions_roles/companies/', component: <RoleCompanies /> },
	// { path: '/permissions_roles/modules/', component: <RoleModules /> },
	// { path: '/permissions_roles/sites/', component: <RoleCompanySites /> },
	{
		path: '/permissions_roles/scope/attachcompanies/',
		component: <AttachCompanies />,
	},
	// { path: '/permissions_roles/companies/attachcompanies/', component: <AttachCompanies /> },
	{ path: '/permissions_roles/scope/sites/', component: <RoleCompanySites /> },
	// { path: '/permissions_roles/companies/sites/', component: <RoleCompanySites /> },
	{
		path: '/permissions_roles/scope/sites/attachsites/',
		component: <AttachSitesToCompany />,
	},
	// { path: '/permissions_roles/companies/sites/attachsites/', component: <AttachSitesToCompany /> },
	{
		path: '/permissions_roles/scope/attachsites/',
		component: <AttachSitesToCompany />,
	},
	// { path: '/permissions_roles/sites/attachsites/', component: <AttachSitesToCompany /> },
	{
		path: '/permissions_roles/scope/attachmodules/',
		component: <AttachModules />,
	},
	// { path: '/permissions_roles/modules/attachmodules/', component: <AttachModules /> },

	{
		path: '/permissions_roles/companies/modules/',
		component: <RoleCompaniesModules />,
	},
	{ path: '/permissions_roles/edit/', component: <RoleCreationPanel /> },
	{ path: '/dev_permission_modules/', component: <Modules /> },
	{ path: '/dev_permission_modules/create/', component: <CreateModule /> },
	{ path: '/dev_permission_templates/', component: <Templates /> },
	{
		path: '/dev_permission_templates/create/',
		component: <TemplateCreationPanel />,
	},
	{
		path: '/dev_permission_templates/modules/',
		component: <TemplateModules />,
	},
	{
		path: '/dev_permission_templates/modules/attachmodules/',
		component: <TemplatesAttachModules />,
	},
	{ path: '/dev_permission_type/', component: <Permissions /> },
	{ path: '/dev_permission_type/create/', component: <CreatePermission /> },
	{ path: '/dev_permission_resource/', component: <ResourcePermissions /> },
	{
		path: '/dev_permission_resource/create/',
		component: <CreateResourcePermission />,
	},
	{ path: '/permissions_teams/', component: <Teams /> },
	{ path: '/permissions_teams/create/', component: <TeamCreatePage /> },
	{ path: '/permissions_teams/users/', component: <TeamUsers /> },
	{ path: '/permissions_teams/users/addusers/', component: <AddUsersInTeam /> },
	{ path: '/company/', component: <Customers /> },
	{ path: '/company/:slug/', component: <CustomerDetailPage /> },
	{ path: '/companymanagement/', component: <Customers /> },
	{ path: '/companymanagement/:slug/', component: <CustomerDetailPage /> },
	{ path: '/time_reporting/', component: <TimeReportingPage /> },
	{ path: '/time_reporting/:slug/', component: <QuickbooksPageDetails /> },
	{ path: '/quickbook/detail/', component: <QuickbooksDetailPage /> },
	{ path: '/integrations/', component: <IntegrationsPage /> },
	{ path: '/services/', component: <STNServicesPage /> },
	{ path: '/alltickets/', component: <AllTickets /> },
	{ path: '/alltickets/:id/', component: <TicketDetailPage /> },
	{ path: '/alltickets/:id/:id', component: <SubtaskDetailPage /> },
	{ path: '/tickets/:id/:id', component: <SubtaskDetailPage /> },
	{ path: '/tickets/', component: <EditCustomerTickets /> },
	{ path: `/tickets/:id`, component: <TicketDetailPage /> },
	{
		path: `/all_projects_tickets/project/:projectId`,
		component: <ProjectDetailPage />,
	},
	{
		path: `/all_projects_tickets/project/:projectId/:ticketId`,
		component: <SubtaskDetailPage />,
	},
	{
		path: `/all_projects_tickets/project/:projectId/:ticketId/:id`,
		component: <SubtaskDetailPage />,
	},
	{
		path: `/all_projects_tickets/ticket/:ticketId`,
		component: <TicketDetailPage />,
	},
	{
		path: `/all_projects_tickets/ticket/:ticketId/:id`,
		component: <SubtaskDetailPage />,
	},
	{
		path: `/all_projects_tickets/ticket/:ticketId/:id/:id`,
		component: <SubtaskDetailPage />,
	},
	{ path: `/all_projects_tickets/:id/:id`, component: <SubtaskDetailPage /> },
	{
		path: `/all_projects_tickets/:id/:id/:id`,
		component: <SubtaskDetailPage />,
	},
	{ path: '/users/', component: <CompanyUsersPage /> },
	{ path: '/all_users/', component: <AllUsersPage /> },
	{ path: '/all_users/:slug/', component: <ProfilePage /> },
	{ path: '/users/:slug/', component: <ProfilePage /> },
	{ path: '/profile/', component: <ProfilePage /> },
	{ path: '/all_projects_tickets/', component: <AllProjectTickets /> },
	{ path: '/allprojects/', component: <AllProjectsPage /> },
	{ path: '/allprojects/:id/', component: <ProjectDetailPage /> },
	{ path: '/allprojects/:id/:id', component: <SubtaskDetailPage /> },
	{ path: '/allprojects/:id/:id/:id', component: <SubtaskDetailPage /> },
	{ path: '/projects/', component: <ProjectsPage /> },
	{ path: '/projects/:id/', component: <ProjectDetailPage /> },
	{ path: '/projects/:id/:id', component: <SubtaskDetailPage /> },
	{ path: '/projects/:id/:id/:id', component: <SubtaskDetailPage /> },
	// {path: '/documents/files/', component: <DocumentStorage />},
	{ path: '/documents/files/', component: <TabularFolderStructure /> },
	// {path: '/documents/diagrams/', component: <DiagramsPage />},
	{ path: '/documents/diagrams/', component: <DiagramsPage /> },
	{ path: '/documents/diagrams/:slug/', component: <DiagramsDetail /> },
	{ path: '/reports/', component: <MSSReportsPage /> },
	{ path: '/audit_logs/', component: <Audits /> },
	{ path: '/logs/', component: <AllLogs /> },
	{ path: '/logout/', component: <Logout /> },
	{ path: '/control_group_templates/', component: <ControlGroupTemplates /> },
	{ path: '/vulnerability_scans/', component: <VulnerabilityScans /> },
	{ path: '/vulnerability_scans_dashboard/', component: <AlertsDashboard /> },
	{ path: '/vulnerability_scans/critical/', component: <EditVulnerability /> },
	{ path: '/assessments/', component: <Assessments /> },
	{ path: '/assessments/:slug/', component: <AssessmentsDetailView /> },
	{ path: '/assessments/detailRewamp/', component: <AssessmentsDetailView /> },
	{ path: '/assessments/create/', component: <AddAssessments /> },
	{ path: '/assessments/edit/', component: <EditAssessment /> },
	{ path: '/tickets_dashboard/', component: <TicketDashboard /> },
	{
		path: '/tickets_dashboard/project/:projectId',
		component: <ProjectDetailPage />,
	},
	{
		path: '/tickets_dashboard/project/:projectId/:ticketId',
		component: <SubtaskDetailPage />,
	},
	{
		path: `/tickets_dashboard/project/:projectId/:ticketId/:id`,
		component: <SubtaskDetailPage />,
	},
	{
		path: '/tickets_dashboard/ticket/:ticketId',
		component: <TicketDetailPage />,
	},
	{
		path: `/tickets_dashboard/ticket/:ticketId/:id`,
		component: <SubtaskDetailPage />,
	},
	{
		path: `/tickets_dashboard/ticket/:ticketId/:id/:id`,
		component: <SubtaskDetailPage />,
	},
	{
		path: '/assessments/vulnerability_scans/multiplescans/',
		component: <MultipleVulnerabilityScansPage />,
	},
	{
		path: '/assessments/vulnerability_scans/multiplescans/detail/',
		component: <VulnerabilityScanDetailPage />,
	},
	{
		path: '/vulnerability_scans/multiplescans/:id/',
		component: <MultipleVulnerabilityScansPage />,
	},
	{
		path: '/vulnerability_scans/multiplescans/detail/',
		component: <VulnerabilityScanDetailPage />,
	},
	{
		path: '/vulnerability_scans/status/',
		component: <VulnerabilityScansDetailStatus />,
	},
	{
		path: '/vulnerability_scans/multiplescans/detail/edit/',
		component: <EditVulnerability />,
	},
	{
		path: '/vulnerability_scans/editStatus/',
		component: <EditVulnerability />,
	},
	{
		path: '/vulnerability_scans/detail/',
		component: <VulnerabilityScanDetailPage />,
	},
	{
		path: '/vulnerability_scans/detail/edit/',
		component: <EditVulnerability />,
	},
	{ path: '/private_networks/', component: <PrivateNetworkPage /> },
	{
		path: '/private_networks/create/',
		component: <PrivateNetworkCreatePage />,
	},
	{
		path: '/managedBackup/clusterSetup/create/',
		component: <ClusterSetupCreatePage />,
	},
	{ path: '/vm_templates/', component: <VMTemplatePage /> },
	{ path: '/vm_templates/add/', component: <AddVMTemplate /> },
	{ path: '/virtual_machines/', component: <VirtualMachinesPage /> },
	{ path: '/managedbackup/', component: <ManagedBackupPage /> },
	{ path: '/createsupportcontract/', component: <SupportContractCreatePage /> },
	{ path: '/clustersetup/edit/', component: <ClusterSetupEditPage /> },
	{ path: '/virtual_gateway/', component: <LoadBalancersPage /> },
	{ path: '/virtual_gateway/create', component: <LoadBalancersCreate /> },
	{ path: '/virtual_gateway/edit', component: <EditLoadBalancer /> },
	{ path: '/virtual_gateway/:slug', component: <LoadBalancersDetail /> },
	{ path: '/all_virtual_gateway/:slug', component: <LoadBalancersDetail /> },
	{ path: '/all_virtual_gateway/', component: <LoadBalancersPage /> },
	{ path: '/all_virtual_gateway/create/', component: <LoadBalancersCreate /> },
	{
		path: '/virtual_machines_dashboard/',
		component: <VirtualMachineDashboardPage />,
	},
	{ path: '/virtual_machines/create/', component: <AllVirtualMAchineCreate /> },
	{
		path: '/all_private_networks/create/',
		component: <PrivateNetworkCreatePage />,
	},
	{ path: '/virtual_machines/:id/', component: <VirtualMachineDetails /> },
	{
		path: '/private_networks/create/',
		component: <PrivateNetworkCreatePage />,
	},
	{ path: '/addusertonotification/', component: <AddUserToNotificationPage /> },
	{ path: '/all_private_networks/', component: <AllPrivateNetworksPage /> },
	{ path: '/all_virtual_machines/', component: <AllVirtualMachinesPage /> },
	{
		path: '/all_virtual_machines/create/',
		component: <AllVirtualMAchineCreate />,
	},
	{ path: '/all_virtual_machines/:id', component: <VirtualMachineDetails /> },
	{ path: '/gpu/', component: <GPUOnePage /> },
	{ path: '/gpuone/', component: <GlobalGpuOnePage /> },
	{ path: '/regions/', component: <RegionsPage /> },
	{ path: '/regions/add', component: <AddRegions /> },
	{ path: '/alert_contacts/', component: <AlertEmailContacts /> },
	{ path: '/manage_notifications/', component: <ManageNotifications /> },
	{ path: '/one_servers/', component: <OneServerPage /> },
	{ path: '/one_servers/add', component: <AddOneServer /> },
	{ path: '/contactUs/', component: <ContactUs /> },
	{
		path: '/vulnerability_scans/dashboard',
		component: <VulnerabilityScansDashboard />,
	},
	{ path: '/alerts_dashboard/', component: <AlertsDashboard /> },
	{ path: '/alerts_policy/', component: <Alerts /> },
	{ path: '/alerts_tools/', component: <AlertsTools /> },
	{
		path: '/alerts_company_service_list/',
		component: <AlertCompanyServiceList />,
	},
	{ path: '/alerts_services/enablealerts/', component: <EnableAlert /> },
	{ path: '/alerts_services/tools_mapping/', component: <AlertsMapping /> },
	{ path: '/alerts_services/tools_projects/', component: <ToolsProjects /> },
	{ path: '/kubernetes/', component: <K8 /> },
	{ path: '/all_kubernetes/', component: <K8 /> },
	{ path: '/kubernetes/create/', component: <CreateK8 /> },
	{ path: '/all_kubernetes/create/', component: <CreateK8 /> },
	{ path: '/kubernetes/:slug', component: <K8DetailPage /> },
	{ path: '/all_kubernetes/:slug', component: <K8DetailPage /> },
	{ path: '/inventory_dashboard/', component: <InventoryDashboard /> },
	{ path: '/inventory_management/', component: <InventoryManagement /> },

	// new grafana dashboard
	{ path: '/grafana_dashboard/', component: <GrafanaDashboard /> },

	// Grafana Dashboard Routes
	{ path: '/grafana/sla-health/', component: <GrafanaSlaHealthPage /> },
	{
		path: '/grafana/overall-system-health/',
		component: <GrafanaOverallSystemHealthPage />,
	},
	{
		path: '/grafana/slurm-monitoring/',
		component: <GrafanaSlurmMonitoringPage />,
	},
	{
		path: '/grafana/cluster-configuration/',
		component: <GrafanaClusterConfigurationPage />,
	},
	{
		path: '/grafana/cluster-utilization/',
		component: <GrafanaClusterUtilizationPage />,
	},
	{ path: '/grafana/node-drilldown/', component: <GrafanaNodeDrilldownPage /> },
	{
		path: '/grafana/dcgm-monitoring/',
		component: <GrafanaDcgmMonitoringPage />,
	},
	{
		path: '/grafana/gpu-utilization/',
		component: <GrafanaGpuUtilizationPage />,
	},
	{
		path: '/grafana/weekly-burn-in-checks/',
		component: <GrafanaWeeklyBurnInChecksPage />,
	},
	{
		path: '/grafana/weekly-sdc-checks/',
		component: <GrafanaWeeklySdcChecksPage />,
	},
	{
		path: '/grafana/network-traffic/',
		component: <GrafanaNetworkTrafficPage />,
	},
	{
		path: '/grafana/weekly-nccl-checks/',
		component: <GrafanaWeeklyNcclChecksPage />,
	},
	{
		path: '/grafana/power-consumption/',
		component: <GrafanaPowerConsumptionPage />,
	},
	{
		path: '/grafana/storage-utilization/',
		component: <GrafanaStorageUtilizationPage />,
	},
	{
		path: '/grafana/logging-overview/',
		component: <GrafanaLoggingOverviewPage />,
	},
	{ path: '/grafana/node-lifecycle/', component: <GrafanaNodeLifecyclePage /> },
];

export default privateRoutes;
